import MapActionTypes from "services/map/types";
import GlobalFiltersActioner from "./actioner";

const GlobalFiltersMiddleware =
  ({ dispatch, getState }) =>
  (next) =>
  (action) => {
    if (typeof action === "function") {
      return action(dispatch, getState);
    }
    if (
      action.type === MapActionTypes.SET_CONFIG_PARAM &&
      action.key === "currentRadius"
    ) {
      dispatch(GlobalFiltersActioner.setParameter("radius", action.value));
    } else if (
      action.type === MapActionTypes.SET_CONFIG_PARAM &&
      action.key === "currentPosition"
    ) {
      dispatch(GlobalFiltersActioner.setParameter("position", action.value));
    } else if (action.type === MapActionTypes.SET_CONFIG) {
      dispatch(
        GlobalFiltersActioner.setParameter(
          "position",
          action.value.default_position
        )
      );
      dispatch(
        GlobalFiltersActioner.setParameter("radius", action.value.radius)
      );
    }

    return next(action);
  };

export default GlobalFiltersMiddleware;
